import {
    getDealerList,
    getDealer,
} from "../apis/api_dealer.js";

import { listMode } from '../utils/table';

const state = {
    filters: { mode: listMode.list, status:'20', brandId:'' },
    items: [],
    item: {},    
};

const getters = {
};

const mutations = {
    SET_DEALER_LIST(state, items){
        state.items = items;
    },

    SET_DEALER(state, payload) {
        state.item = payload
    },

    CLEAR_DEALER(state) {
        state.item = {};
    },
};

const actions = {

    async GET_DEALER_LIST({ state, commit }, params) {
        try {
            let filters = { ...state.filters, ...params }
            const response = await getDealerList(filters);
            commit('SET_DEALER_LIST', response.data.data.content)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },

    async GET_DEALER({ commit }, id) {
        try {
            const response = await getDealer(id);
            commit('SET_DEALER', response.data.data)
            return response.data.data;
        } catch (e) {
            return Promise.reject(e);
        }
    },    
};

export default {mutations, state, actions, getters};